<template>
  <div class="page-container">
    <div class="page-header">
      <h2>小程序管理</h2>
    </div>

    <div class="filter-bar">
      <el-select v-if="!isServiceProvider" v-model="filterForm.serviceProviderId" placeholder="选择服务商" size="small" style="width: 200px;">
        <el-option label="全部" :value="undefined" />
        <el-option v-for="shop in serviceProviders" :key="shop.id" :label="shop.name" :value="shop.id" />
      </el-select>
      <el-input
        v-model="filterForm.name"
        placeholder="小程序名称"
        size="small"
        :style="{ marginLeft: isServiceProvider ? '0' : '10px', width: '200px' }"
      />
      <el-select v-model="filterForm.status" placeholder="状态" size="small" style="width: 120px; margin-left: 10px;">
        <el-option label="全部" :value="undefined" />
        <el-option label="正常" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" size="small" style="margin-left: 10px;" @click="loadData">查询</el-button>
      <el-button type="default" size="small" style="margin-left: 10px;" @click="handleReset">重置</el-button>
      <el-button type="success" size="small" style="margin-left: 10px;" @click="showAddDialog">新增小程序</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="name" label="小程序名称" min-width="150" />
      <el-table-column prop="appId" label="AppID" min-width="150" />
      <el-table-column prop="contactName" label="联系人" width="100" />
      <el-table-column prop="contactPhone" label="联系电话" width="120" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="160" align="center" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editRow(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="viewAdmins(scope.row)">管理员</el-button>
          <el-button
            type="text"
            size="small"
            style="color: #F56C6C;"
            @click="deleteRow(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑小程序' : '新增小程序'" :visible.sync="showDialog" width="900px">
      <el-form ref="miniAppForm" :model="form" label-width="130px">
        <el-form-item label="服务商" prop="serviceProviderId">
          <el-select v-model="form.serviceProviderId" placeholder="请选择服务商" style="width: 100%;" :disabled="isServiceProvider">
            <el-option v-for="shop in filteredServiceProviders" :key="shop.id" :label="shop.name" :value="shop.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="小程序名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入小程序名称" />
        </el-form-item>
        <el-form-item label="AppID" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入支付宝AppID（同时作为小程序编码）" />
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="form.contactName" placeholder="请输入联系人姓名" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <el-input v-model="form.contactEmail" placeholder="请输入联系邮箱" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入描述" />
        </el-form-item>
        
        <el-divider content-position="left">支付配置</el-divider>
        
        <el-form-item label="Private Key" prop="privateKey">
          <el-input v-model="form.privateKey" type="textarea" :rows="4" placeholder="请输入支付私钥（Private Key）" />
        </el-form-item>
        
        <el-divider content-position="left">证书配置</el-divider>

        <el-form-item label="应用公钥证书路径" prop="appCertPath">
          <el-input v-model="form.appCertPath" placeholder="如：/data/certs/appCertPublicKey_2021005177605989.crt" />
          <div class="form-tip">证书文件的绝对路径或相对路径（相对于项目根目录）</div>
        </el-form-item>
        <el-form-item label="支付宝公钥证书路径" prop="alipayCertPath">
          <el-input v-model="form.alipayCertPath" placeholder="如：/data/certs/alipayCertPublicKey_RSA2.crt" />
          <div class="form-tip">证书文件的绝对路径或相对路径</div>
        </el-form-item>
        <el-form-item label="支付宝根证书路径" prop="rootCertPath">
          <el-input v-model="form.rootCertPath" placeholder="如：/data/certs/alipayRootCert.crt" />
          <div class="form-tip">证书文件的绝对路径或相对路径</div>
        </el-form-item>
        
        <el-divider content-position="left">接口配置</el-divider>
        
        <el-form-item label="网关地址" prop="gatewayUrl">
          <el-input v-model="form.gatewayUrl" placeholder="请输入支付宝网关地址" />
        </el-form-item>
        <el-form-item label="异步通知地址" prop="notifyUrl">
          <el-input v-model="form.notifyUrl" placeholder="请输入异步通知地址" />
        </el-form-item>
        <el-form-item label="同步返回地址" prop="returnUrl">
          <el-input v-model="form.returnUrl" placeholder="请输入同步返回地址" />
        </el-form-item>
        
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="签名类型" prop="signType">
              <el-input v-model="form.signType" placeholder="如 RSA2" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="字符集" prop="charset">
              <el-input v-model="form.charset" placeholder="如 UTF-8" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据格式" prop="format">
              <el-input v-model="form.format" placeholder="如 json" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="AES加密密钥" prop="encryptKey">
          <el-input v-model="form.encryptKey" placeholder="请输入AES加密密钥" />
        </el-form-item>
        
        <el-divider content-position="left">芝麻信用配置</el-divider>
        
        <el-form-item label="芝麻服务ID" prop="zmServiceId">
          <el-input v-model="form.zmServiceId" placeholder="请输入芝麻信用服务ID" />
        </el-form-item>
        <el-form-item label="租赁类目ID" prop="rentPhoneCategoryId">
          <el-input v-model="form.rentPhoneCategoryId" placeholder="如 RENT_PHONE" />
        </el-form-item>
        
        <el-divider content-position="left">租安盾配置</el-divider>
        
        <el-form-item label="长租策略ID" prop="longRentRiskSchemeId">
          <el-input v-model="form.longRentRiskSchemeId" placeholder="请输入长租租安盾策略ID" />
        </el-form-item>
        <el-form-item label="短租策略ID" prop="shortRentRiskSchemeId">
          <el-input v-model="form.shortRentRiskSchemeId" placeholder="请输入短租租安盾策略ID" />
        </el-form-item>
        

        <el-divider content-position="left">商品配置</el-divider>

        <el-form-item label="商品数量">
          <el-switch v-model="form.enableQuantity" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭" />
          <div class="form-tip">关闭时默认为1件，不可调整；开启时用户可自定义购买数量</div>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 管理员列表弹窗 -->
    <el-dialog title="平台管理员" :visible.sync="showAdminsDialog" width="800px">
      <el-table :data="admins" v-loading="adminsLoading" border>
        <el-table-column prop="username" label="用户名" />
        <el-table-column prop="realName" label="真实姓名" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="email" label="邮箱" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getMiniAppPage, createMiniApp, updateMiniApp, deleteMiniApp } from '@/api/miniApp'
import { getServiceProviderList } from '@/api/serviceProvider'
import { getAdminList } from '@/api/admin'

export default {
  name: 'MiniAppList',
  data() {
    return {
      isServiceProvider: false,
      serviceProviders: [],
      filterForm: {
        serviceProviderId: '',
        name: '',
        status: ''
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showDialog: false,
      saving: false,
      form: {
        id: null,
        serviceProviderId: '',
        name: '',
        code: '',
        appId: '',
        appSecret: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        description: '',
        // 支付配置
        payPrivateKey: '',
        payPublicKey: '',
        alipayPublicKey: '',
        // 证书配置
        appCertPath: '',
        alipayCertPath: '',
        rootCertPath: '',
        // 接口配置
        gatewayUrl: '',
        notifyUrl: '',
        returnUrl: '',
        signType: 'RSA2',
        charset: 'UTF-8',
        format: 'json',
        encryptKey: '',
        // 芝麻信用配置
        zmServiceId: '',
        rentPhoneCategoryId: 'RENT_PHONE',
        // 租安盾策略配置
        longRentRiskSchemeId: '',
        shortRentRiskSchemeId: '',
        enableQuantity: 0,
        status: 1
      },
      showAdminsDialog: false,
      admins: [],
      adminsLoading: false,
      currentMiniApp: null
    }
  },
  mounted() {
    // 判断当前用户是否是服务商角色
    const adminInfo = localStorage.getItem('admin_info')
    if (adminInfo) {
      try {
        const info = JSON.parse(adminInfo)
        this.isServiceProvider = info.admin?.roleType === 'SERVICE_PROVIDER'
        if (this.isServiceProvider) {
          this.currentServiceProviderId = info.serviceProviderId
        }
      } catch (e) {
        console.error('解析用户信息失败', e)
      }
    }
    
    this.loadServiceProviders()
    this.loadData()
  },
  computed: {
    // 服务商角色只能看到自己的服务商
    filteredServiceProviders() {
      if (this.isServiceProvider && this.currentServiceProviderId) {
        return this.serviceProviders.filter(shop => shop.id === this.currentServiceProviderId)
      }
      return this.serviceProviders
    }
  },
  methods: {
    async loadServiceProviders() {
      try {
        const res = await getServiceProviderList()
        this.serviceProviders = res.data || []
      } catch (e) {
        this.$message.error('加载服务商失败')
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          name: this.filterForm.name || undefined,
          status: this.filterForm.status || undefined
        }
        
        // 服务商角色自动传递自己的 serviceProviderId
        if (this.isServiceProvider) {
          const adminInfo = localStorage.getItem('admin_info')
          if (adminInfo) {
            try {
              const info = JSON.parse(adminInfo)
              params.serviceProviderId = info.serviceProviderId
            } catch (e) {
              console.error('解析用户信息失败', e)
            }
          }
        } else {
          // 非服务商角色使用筛选条件
          params.serviceProviderId = this.filterForm.serviceProviderId || undefined
        }
        
        const res = await getMiniAppPage(params)
        this.list = res.data?.records || res.data?.list || []
        this.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleReset() {
      this.filterForm = {
        serviceProviderId: '',
        name: '',
        status: ''
      }
      this.loadData()
    },
    showAddDialog() {
      this.form = {
        id: null,
        serviceProviderId: '',
        name: '',
        appId: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        description: '',
        privateKey: '',
        appCertPath: '',
        alipayCertPath: '',
        rootCertPath: '',
        gatewayUrl: 'https://openapi.alipay.com/gateway.do',
        notifyUrl: '',
        returnUrl: '',
        signType: 'RSA2',
        charset: 'UTF-8',
        format: 'json',
        encryptKey: '',
        zmServiceId: '',
        rentPhoneCategoryId: 'RENT_PHONE',
        longRentRiskSchemeId: '',
        shortRentRiskSchemeId: '',
        enableQuantity: 0,
        status: 1
      }
      this.showDialog = true
    },
    editRow(row) {
      this.form = {
        id: row.id,
        serviceProviderId: row.serviceProviderId,
        name: row.name,
        appId: row.appId,
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        contactEmail: row.contactEmail,
        description: row.description,
        privateKey: row.privateKey || '',
        appCertPath: row.appCertPath || '',
        alipayCertPath: row.alipayCertPath || '',
        rootCertPath: row.rootCertPath || '',
        gatewayUrl: row.gatewayUrl || '',
        notifyUrl: row.notifyUrl || '',
        returnUrl: row.returnUrl || '',
        signType: row.signType || 'RSA2',
        charset: row.charset || 'UTF-8',
        format: row.format || 'json',
        encryptKey: row.encryptKey || '',
        zmServiceId: row.zmServiceId || '',
        rentPhoneCategoryId: row.rentPhoneCategoryId || 'RENT_PHONE',
        longRentRiskSchemeId: row.longRentRiskSchemeId || '',
        shortRentRiskSchemeId: row.shortRentRiskSchemeId || '',
        enableQuantity: row.enableQuantity != null ? row.enableQuantity : 0,


      }
      this.showDialog = true
    },
    async handleSave() {
      if (!this.form.serviceProviderId) {
        this.$message.warning('请选择服务商')
        return
      }
      if (!this.form.name) {
        this.$message.warning('请输入小程序名称')
        return
      }
      if (!this.form.appId) {
        this.$message.warning('请输入AppID')
        return
      }
      this.saving = true
      try {
        if (this.form.id) {
          await updateMiniApp(this.form.id, this.form)
        } else {
          await createMiniApp(this.form)
        }
        this.$message.success('保存成功')
        this.showDialog = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async deleteRow(row) {
      try {
        const res = await this.$confirm('确定删除该小程序？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (res === 'confirm') {
          await deleteMiniApp(row.id)
          this.$message.success('删除成功')
          this.loadData()
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    async viewAdmins(row) {
      this.currentMiniApp = row
      this.adminsLoading = true
      try {
        const res = await getAdminList({ miniAppId: row.id })
        this.admins = res.data || []
        this.showAdminsDialog = true
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.adminsLoading = false
      }
    }
  }
}
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
</style>

<style scoped>
.page-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.filter-bar {
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
